const isNumber = (c) => !Number.isNaN(Number(c)) && c !== ' ';
export default function stripNonNumbers(phn) {
    return phn
        .split('')
        .filter(isNumber)
        .join('');
}
